export const RadiologyQueueCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  borderLeft: (el, s) => s.urgency === 'urgent' ? '4px solid red' : '1px solid inkBorder',

  TopRow: {
    flow: 'x',
    align: 'center space-between',
    ImagingBadge: {
      tag: 'span',
      text: (el, s) => s.imagingType || 'Periapical',
      fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B',
      background: 'teal.15', color: 'teal'
    },
    StatusBadge: {
      tag: 'span',
      text: (el, s) => {
        const st = s.status || 'pending'
        if (st === 'pending') return 'Pending'
        if (st === 'inProgress') return 'In Progress'
        if (st === 'completed') return 'Completed'
        return st
      },
      fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B',
      background: (el, s) => {
        const st = s.status || 'pending'
        if (st === 'pending') return 'amber.15'
        if (st === 'inProgress') return 'blue.15'
        if (st === 'completed') return 'teal.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.status || 'pending'
        if (st === 'pending') return 'amber'
        if (st === 'inProgress') return 'blue'
        if (st === 'completed') return 'teal'
        return 'inkMuted'
      }
    }
  },

  PatientName: { text: (el, s) => s.patientName || 'Patient Name', fontSize: 'A', fontWeight: '600', color: 'inkText' },
  ReferringDoctor: { text: (el, s) => s.referringDoctor || 'Dr. Smith', fontSize: 'Z', color: 'inkMuted' },
  TargetArea: { text: (el, s) => s.targetArea ? 'Target: ' + s.targetArea : '', fontSize: 'Z', color: 'inkSubtle', show: (el, s) => !!s.targetArea },
  ClinicalQuestion: { text: (el, s) => s.clinicalQuestion || '', fontSize: 'Z', color: 'inkSubtle', fontStyle: 'italic', show: (el, s) => !!s.clinicalQuestion },
  Timestamp: { text: (el, s) => s.createdAt || '', fontSize: 'Y', color: 'inkSubtle' },

  UrgencyTag: {
    tag: 'span',
    text: 'URGENT',
    fontSize: 'Y', fontWeight: '700', color: 'red',
    show: (el, s) => s.urgency === 'urgent'
  },

  Actions: {
    flow: 'x', gap: 'Y', marginTop: 'Y',
    StartBtn: {
      tag: 'button', text: '{{ startImaging | polyglot }}',
      padding: 'Y Z', round: 'Z', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', border: 'none',
      background: 'blue', color: 'white',
      show: (el, s) => s.status === 'pending',
      onClick: (e, el, s) => {
        const queue = (s.root.radiologyQueue || []).map(r => r.id === s.id ? { ...r, status: 'inProgress' } : r)
        s.root.update({ radiologyQueue: queue })
      }
    },
    CompleteBtn: {
      tag: 'button', text: '{{ markComplete | polyglot }}',
      padding: 'Y Z', round: 'Z', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', border: 'none',
      background: 'teal', color: 'white',
      show: (el, s) => s.status === 'inProgress',
      onClick: (e, el, s) => {
        const queue = (s.root.radiologyQueue || []).map(r => r.id === s.id ? { ...r, status: 'completed' } : r)
        s.root.update({ radiologyQueue: queue })
      }
    },
    CompletedLabel: {
      tag: 'span', text: '{{ completed | polyglot }}',
      fontSize: 'Y', fontWeight: '600', color: 'teal',
      show: (el, s) => s.status === 'completed'
    }
  }
}
